import { BreadType } from './bread'
export const itemTypes = ['item' as const]
export type ItemType = (typeof itemTypes)[number]
export type Item = {
  id: string
  bread: BreadType
  type: ItemType
}
export type ItemWithIndex = Item & { index: number }
export type MoveHandler = (dragIndex: number, targetIndex: number) => void
